import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Sticky from 'react-stickynode';
import { compose } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import find from 'lodash/find';
import get from 'lodash/get';

import { signOut } from 'actions/auth';
import isApplicationFiltersLoaded from 'components/Hoc/isApplicationFiltersLoaded';
import { ButtonLink } from 'components/Button';
import { appConfig } from 'config/appConfig';
import style from './style.scss';

export const Header = (props) => {
  const dispatch = useDispatch();
  const [isMenuActive, setIsMenuActive] = useState(false);

  const { envLabel } = appConfig;
  const { isApplicationReviewDataLoaded } = props;
  const isPreSelection = get(
    find(
      JSON.parse(localStorage.getItem('features')),
      { code: 'preselection' }
    ),
    'value'
  ) === 'Enabled';

  const handleMenuHover = (e) => {
    e.preventDefault();
    setIsMenuActive(true);
  };

  const handleMouseLeave = (e) => {
    e.preventDefault();
    setIsMenuActive(false);
  };

  const handleClickButton = (url, e) => {
    e.preventDefault();
    props.history.push(url);
  };

  return (
    <Sticky
      enabled
      innerZ={10000}
    >
      <header className="site-header" role="banner">
        <div className="site-navigation top-bar portal-bar" role="navigation" data-sticky data-options="marginTop:0;" data-top-anchor="1">
          <div className="top-bar-left position-relative">
            <div className="site-desktop-title top-bar-title d-flex align-items-center postion-relative">
              <Link to="/dashboard">LendingUSA</Link>
              { envLabel && envLabel !== 'production' && <div className={style.envLabel}>{ envLabel }</div> }
            </div>
          </div>
          {
            localStorage.idToken ?
              <Fragment>
                <div className="top-bar-center show-for-large">
                  <ul className="menu">
                    <li className="menu-item">
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li className="menu-item">
                      <Link
                        to={isApplicationReviewDataLoaded
                          ? '/dashboard/application-review/action/AllApplications'
                          : ''
                        }
                      >
                        Applications
                      </Link>
                    </li>
                    {isPreSelection && (
                      <li className="menu-item">
                        <Link
                          to={isApplicationReviewDataLoaded
                            ? '/dashboard/pre-selection-review/action/AllApplications'
                            : ''
                          }
                        >
                          Pre-Selections
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
                <div className="top-bar-right">
                  <ul className="dropdown menu desktop-menu cell shrink" data-dropdown-menu onMouseEnter={handleMenuHover} onMouseLeave={handleMouseLeave}>
                    <li className={cn('menu-item is-dropdown-submenu-parent opens-left', isMenuActive && 'is-active')}>
                      <a href="#fef">
                        <span>My Account</span>
                        {localStorage.getItem('idToken') && (localStorage.getItem('user.firstName') || localStorage.getItem('user.username'))}
                      </a>
                      <ul className={cn('menu vertical dropdown submenu is-dropdown-submenu first-sub', isMenuActive && 'js-dropdown-active')}>
                        <li className="is-submenu-item is-dropdown-submenu-item">
                          <ButtonLink
                            onClick={handleClickButton.bind(null, '/dashboard/profile')}
                            className={style.buttonLink}
                          >
                            Profile Settings
                          </ButtonLink>
                        </li>
                        <li className="is-submenu-item is-dropdown-submenu-item">
                          <ButtonLink onClick={() => dispatch(signOut())} className={style.buttonLink}>Logout</ButtonLink>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <a href="tel:+18885028027" className="phone"><span>Questions?</span> (888) 502-8027</a>
                </div>
              </Fragment>
            :
              <a href="tel:+18885028027" className="phone"><span>Questions?</span> (888) 502-8027</a>
          }
        </div>
      </header>
    </Sticky>
    // <!-- End Portal Header -->
    // End Global Header
  );
};

Header.propTypes = {
  history: PropTypes.object.isRequired,
  isApplicationReviewDataLoaded: PropTypes.bool,
};

Header.defaultProps = {
  isApplicationReviewDataLoaded: true,
};

export default compose(
  withRouter,
  isApplicationFiltersLoaded
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/index.js